import List from "./List";
export default List;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-virtual-list/es/index.js
// module id = 1260
// module chunks = 0